import { displaySidebarVideoBackgrounds, fetchMediaFiles } from '~video';

export const onChangeVideo = async () => {
  await fetchMediaFiles();
  await displaySidebarVideoBackgrounds();
};
